export const websiteBuilderZLayers = {
  previewContainer: 0,
  designSpace: {
    outerFrame: 0,
    elementOverride: 999_999,
    sectionEditorUI: 1_000_000,
  },
  shell: {
    underlay: 99,
    ui: 100,
  },
  portal: 999,
  dragLayer: 9999,
} as const;
